export const businessInformation = {
  corporation: {
    heading: 'Corporation tax filing and payment deadlines',
    subheading: 'Accounting year end date',
    data: [
      {
        key: '31/12/2022',
        values: {
          accountsToCompaniesHouse: '30/09/2023',
          corpTaxDue: '01/10/2023',
          taxReturnDue: '31/12/2023'
        },
        default: true
      },
      {
        key: '31/01/2023',
        values: {
          accountsToCompaniesHouse: '31/10/2023',
          corpTaxDue: '01/11/2023',
          taxReturnDue: '31/01/2024'
        }
      },
      {
        key: '28/02/2023',
        values: {
          accountsToCompaniesHouse: '30/11/2023',
          corpTaxDue: '01/12/2023',
          taxReturnDue: '29/02/2024'
        }
      },
      {
        key: '31/03/2023',
        values: {
          accountsToCompaniesHouse: '31/12/2023',
          corpTaxDue: '01/01/2024',
          taxReturnDue: '31/03/2024'
        }
      },
      {
        key: '30/04/2023',
        values: {
          accountsToCompaniesHouse: '31/01/2024',
          corpTaxDue: '01/02/2024',
          taxReturnDue: '30/04/2024'
        }
      },
      {
        key: '31/05/2023',
        values: {
          accountsToCompaniesHouse: '28/02/2024',
          corpTaxDue: '01/03/2024',
          taxReturnDue: '31/05/2024'
        }
      },
      {
        key: '30/06/2023',
        values: {
          accountsToCompaniesHouse: '31/03/2024',
          corpTaxDue: '01/04/2024',
          taxReturnDue: '30/06/2024'
        }
      },
      {
        key: '31/07/2023',
        values: {
          accountsToCompaniesHouse: '30/04/2024',
          corpTaxDue: '01/05/2024',
          taxReturnDue: '31/07/2024'
        }
      },
      {
        key: '31/08/2023',
        values: {
          accountsToCompaniesHouse: '31/05/2024',
          corpTaxDue: '01/06/2024',
          taxReturnDue: '31/08/2024'
        }
      },
      {
        key: '30/09/2023',
        values: {
          accountsToCompaniesHouse: '30/06/2024',
          corpTaxDue: '01/07/2024',
          taxReturnDue: '30/09/2024'
        }
      },
      {
        key: '31/10/2023',
        values: {
          accountsToCompaniesHouse: '31/07/2024',
          corpTaxDue: '01/08/2024',
          taxReturnDue: '31/10/2024'
        }
      },
      {
        key: '30/11/2023',
        values: {
          accountsToCompaniesHouse: '31/08/2024',
          corpTaxDue: '01/09/2024',
          taxReturnDue: '31/11/2024'
        }
      },
      {
        key: '31/12/2023',
        values: {
          accountsToCompaniesHouse: '30/09/2024',
          corpTaxDue: '01/10/2024',
          taxReturnDue: '31/12/2024'
        }
      }
    ]
  },
  vat: {
    heading: 'VAT reporting and payment deadlines',
    subheading: 'VAT quarter ended',
    data: [
      { key: '31/12/2022', values: { dueDate: '07/02/2023' }, default: true },
      { key: '31/01/2023', values: { dueDate: '07/03/2023' } },
      { key: '28/02/2023', values: { dueDate: '07/04/2023' } },
      { key: '31/03/2023', values: { dueDate: '07/05/2023' } },
      { key: '30/04/2023', values: { dueDate: '07/06/2023' } },
      { key: '31/05/2023', values: { dueDate: '07/07/2023' } },
      { key: '30/06/2023', values: { dueDate: '07/08/2023' } },
      { key: '31/07/2023', values: { dueDate: '07/09/2023' } },
      { key: '31/08/2023', values: { dueDate: '07/10/2023' } },
      { key: '30/09/2023', values: { dueDate: '07/11/2023' } },
      { key: '31/10/2023', values: { dueDate: '07/12/2023' } },
      { key: '30/11/2023', values: { dueDate: '07/01/2024' } },
      { key: '31/12/2023', values: { dueDate: '07/02/2024' } }
    ]
  }
};
